<template>
  <div
    class="crew-timesheet-edit flex w-full justify-start"
    style="flex-direction: column;"
  >
    <div
      ref="crewTimesheetEditForm"
      style="height: calc(100vh - 160px); overflow-y: scroll; margin: 0 0.2rem;"
      @scroll="onFormScroll"
    >
      <div class="ml-2 mt-2 mb-4 required aisea-text-16-400-black">
        必要事項を入力してください。「<label></label>」は入力必須項目です。
      </div>

      <div class="flex w-full justify-start crew-timesheet-edit-form-row">
        <div class="flex w-full justify-start">
          <div class="flex justify-start items-start" style="width: 50%;">
            <div class="w-full required" style="position:relative;">
              <label class="vs-input--label">作業開始日時</label>
              <div
                style="position:absolute; top: 2.2rem; left: 0.8rem; z-index: 9; "
              >
                <feather-icon
                  icon="CalendarIcon"
                  svgClasses="h-4 w-4"
                  class="calendar-icon"
                />
              </div>
              <datepicker
                name="daytime_in"
                :language="ja"
                :format="formatter"
                :typeable="false"
                placeholder="作業開始日を選択"
                v-model="daytimeInDate"
                v-validate="'required'"
                data-vv-as="開始日"
                :disabled-dates="disabledDates"
                @closed="validateForDatetimeRange"
              ></datepicker>
              <span
                class="text-danger text-sm"
                style="margin-left: 0.6rem;"
                v-show="errors.has('daytimeInDate')"
                >{{ errors.first("daytimeInDate") }}</span
              >
              <span
                class="text-danger text-sm"
                style="margin-left: 0.6rem;"
                v-show="errors.has('daytimeInDateDuplication')"
                >{{ errors.first("daytimeInDateDuplication") }}</span
              >
            </div>
          </div>

          <div
            class="pl-4 flex justify-start items-start"
            style="width: 50%; margin-top: 21px;"
          >
            <div class="w-full required" style="position:relative;">
              <flat-pickr
                v-model="daytimeInTime"
                placeholder="作業開始時間を選択してください"
                :config.sync="configTimePicker"
                class="w-full aisea-text-16-400-dark-gray"
                ref="daytimeInTimePicker"
              />
              <span
                class="text-danger text-sm"
                style="margin-left: 0.6rem;"
                v-show="errors.has('daytimeInTime')"
                >{{ errors.first("daytimeInTime") }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="flex w-full justify-start crew-timesheet-edit-form-row">
        <div class="flex w-full justify-start">
          <div class="flex justify-start items-start" style="width: 50%;">
            <div class="w-full required" style="position:relative;">
              <label class="vs-input--label">作業終了日時</label>
              <div
                style="position:absolute; top: 2.2rem; left: 0.8rem; z-index: 9; "
              >
                <feather-icon
                  icon="CalendarIcon"
                  svgClasses="h-4 w-4"
                  class="calendar-icon"
                />
              </div>
              <datepicker
                name="daytime_in"
                :language="ja"
                :format="formatter"
                :typeable="false"
                placeholder="作業終了日を選択"
                v-model="daytimeOutDate"
                v-validate="'required'"
                data-vv-as="終了日"
                :disabled-dates="disabledDates"
                @closed="validateForDatetimeRange"
              ></datepicker>
              <span
                class="text-danger text-sm"
                style="margin-left: 0.6rem;"
                v-show="errors.has('daytimeOutDate')"
                >{{ errors.first("daytimeOutDate") }}</span
              >
              <span
                class="text-danger text-sm"
                style="margin-left: 0.6rem;"
                v-show="errors.has('daytimeOutDateDuplication')"
                >{{ errors.first("daytimeOutDateDuplication") }}</span
              >
            </div>
          </div>

          <div
            class="pl-4 flex justify-start items-start"
            style="width: 50%; margin-top: 21px;"
          >
            <div class="w-full required" style="position:relative;">
              <flat-pickr
                v-model="daytimeOutTime"
                placeholder="作業終了時間を選択してください"
                :config.sync="configTimePicker"
                class="w-full aisea-text-16-400-dark-gray"
                ref="daytimeOutTimePicker"
              />
              <span
                class="text-danger text-sm"
                style="margin-left: 0.6rem;"
                v-show="errors.has('daytimeOutTime')"
                >{{ errors.first("daytimeOutTime") }}</span
              >
            </div>
          </div>
        </div>
        <div class="flex w-full justify-start">
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem;"
            v-show="errors.has('daytime_range')"
            >{{ errors.first("daytime_range") }}</span
          >
        </div>
      </div>

      <div
        class="flex w-full justify-start items-start crew-timesheet-edit-form-row"
      >
        <div class="flex w-full required" style="flex-direction: column;">
          <label class="vs-input--label">作業内容</label>
          <v-select
            placeholder="作業内容を選択してください"
            class="w-full"
            label="dispLabel"
            name="crewTask"
            :options="dispCrewTasks"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="crewTask"
            v-validate="'required'"
            data-vv-as="作業内容"
            :clearable="false"
          >
            <template v-slot:no-options>作業内容が見つかりません</template>
          </v-select>
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem;"
            v-show="errors.has('approverAuthority')"
            >{{ errors.first("approverAuthority") }}</span
          >
        </div>
      </div>

      <div
        class="flex w-full justify-start items-start crew-timesheet-edit-form-row"
      >
        <div class="flex w-full" style="flex-direction: column;">
          <label class="vs-input--label">ステータス</label>
          <div
            class="flex w-full justify-start items-center"
            style="height: 2.6rem; border-radius: 4px; border: 1px dotted silver; padding: 0 0.6rem;"
            :style="{ 'background-color': '#F8F8F8' }"
          >
            <div
              class="aisea-text-16-400-black"
              :style="{ color: AISEA_COLOR.SLIGHTLY_GRAY }"
            >
              {{ crewTimesheetStatusMap[localData.display_status] }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex w-full justify-start items-start crew-timesheet-edit-form-row"
      >
        <div class="flex w-full" style="flex-direction: column;">
          <label class="vs-input--label">修正日時</label>
          <div
            class="flex w-full justify-start items-center"
            style="height: 2.6rem; border-radius: 4px; border: 1px dotted silver; padding: 0 0.6rem;"
            :style="{ 'background-color': '#F8F8F8' }"
          >
            <div
              class="aisea-text-16-400-black"
              :style="{ color: AISEA_COLOR.SLIGHTLY_GRAY }"
            >
              {{ dispUpdatedAt }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex w-full justify-start items-start crew-timesheet-edit-form-row"
      >
        <div class="flex w-full" style="flex-direction: column;">
          <label class="vs-input--label">修正者</label>
          <div
            class="flex w-full justify-start items-center"
            style="height: 2.6rem; border-radius: 4px; border: 1px dotted silver; padding: 0 0.6rem;"
            :style="{ 'background-color': '#F8F8F8' }"
          >
            <div
              class="aisea-text-16-400-black"
              :style="{ color: AISEA_COLOR.SLIGHTLY_GRAY }"
            >
              {{ localData.changer }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex w-full justify-start items-start crew-timesheet-edit-form-row"
      >
        <div class="flex w-full required" style="flex-direction: column;">
          <label class="vs-input--label">修正コメント</label>
          <vs-textarea
            v-model="commentMemo"
            placeholder="コメントを入力"
            v-validate="'required|max:140'"
            name="comment_memo"
            data-vv-as="コメント"
          />
          <span
            class="text-danger text-sm ml-2"
            style="margin-top: -14px;"
            v-show="errors.has('comment_memo')"
            >{{ errors.first("comment_memo") }}</span
          >
        </div>
      </div>

      <div
        v-if="localData.timesheet_history_list !== null"
        class="flex w-full justify-start items-start crew-timesheet-edit-form-row"
      >
        <div class="flex w-full" style="flex-direction: column;">
          <label class="vs-input--label">修正履歴</label>
          <div
            class="mt-2 p-2 aisea-text-16-400-dark-gray"
            style="border-radius: 8px;"
            :style="{
              'background-color': '#F8F8F8',
              border: `1px solid ${AISEA_COLOR.SLIGHTLY_GRAY}`,
            }"
          >
            <div style="height: 26rem; overflow-y: auto;">
              <div
                v-for="(timesheetHistory, index) in timesheetHistoryList"
                :key="index"
              >
                <div class="mb-10" style="flex-direction: column;">
                  <div class="my-1">
                    ・修正日時：{{ formatYmdhmJa(timesheetHistory.created_at) }}
                  </div>
                  <div class="my-1">
                    ・修正者：{{ timesheetHistory.changer }}
                  </div>
                  <div class="my-1">・修正履歴：</div>
                  <div class="mt-1 ml-4">＜修正前＞</div>
                  <template v-if="index > 0">
                    <div class="my-0 ml-4">
                      作業内容：{{
                        getCrewTaskLabel(
                          localData.timesheet_history_list[index - 1].crew_task
                        )
                      }}
                    </div>
                    <div class="my-0 ml-4">
                      作業開始日時：{{
                        formatYmdhmJa(
                          localData.timesheet_history_list[index - 1].daytime_in
                        )
                      }}
                    </div>
                    <div class="my-0 ml-4">
                      作業終了日時：{{
                        formatYmdhmJa(
                          localData.timesheet_history_list[index - 1]
                            .daytime_out
                        )
                      }}
                    </div>
                  </template>
                  <template v-else>
                    <div class="my-0 ml-4">-</div>
                  </template>
                  <div class="mt-1 ml-4">＜修正後＞</div>
                  <div class="my-0 ml-4">
                    作業内容：{{ getCrewTaskLabel(timesheetHistory.crew_task) }}
                  </div>
                  <div class="my-0 ml-4">
                    作業開始日時：{{
                      formatYmdhmJa(timesheetHistory.daytime_in)
                    }}
                  </div>
                  <div class="my-0 ml-4">
                    作業終了日時：{{
                      formatYmdhmJa(timesheetHistory.daytime_out)
                    }}
                  </div>
                  <div class="mt-1">・修正コメント：</div>
                  <div class="my-0 ml-4" style="white-space: pre;">
                    {{ timesheetHistory.memo || "-" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex w-full justify-end items-center">
        <div style="margin: 0.8rem;">
          <vs-button
            type="flat"
            style="width: 6rem; padding: 0.4rem;"
            :style="{ 'background-color': AISEA_COLOR.WHITE }"
            @click="onCancel"
            :color="AISEA_COLOR.GRAY"
            >キャンセル</vs-button
          >
        </div>
        <div style="margin: 0.8rem;">
          <vs-button
            style="width: 6rem; padding: 0.4rem;"
            @click="onSubmit"
            :disabled="!validateForm"
            :color="AISEA_COLOR.BLUE"
            >保存</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment-timezone";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import DatepickerMixin from "@/mixins/DatepickerMixin";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseCrewTimesheetApi = AiseaApiFactory.get(
  "enterpriseCrewTimesheet"
);
const enterpriseCrewTimesheetApprovalApi = AiseaApiFactory.get(
  "enterpriseCrewTimesheetApproval"
);

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("crewTimesheet");
const { mapState: mapStateOfCrewAccount } = createNamespacedHelpers(
  "crewAccount"
);
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  name: "CrewTimesheetEdit",
  components: {
    vSelect,
    Datepicker,
    flatPickr,
  },
  mixins: [DatepickerMixin, DeviceInfoMixin, ColorMixin],
  props: {
    inputParam: Object,
    activeSidebarCrew: Boolean,
  },
  data() {
    return {
      localData: {},
      disabledDates: {},
      configTimePicker: {
        enableTime: true,
        noCalendar: true,
        minuteIncrement: 1,
        time_24hr: true,
        dateFormat: "H:i",
        minTime: "00:00",
        maxTime: "23:59",
        locale: Japanese,
      },
      daytimeInDate: null,
      daytimeInTime: null,
      daytimeOutDate: null,
      daytimeOutTime: null,
      crewTask: null,
      commentMemo: null,

      canSelectApproverAuthority: false,
    };
  },
  computed: {
    ...mapState({
      crewTasks: state => state.crewTasks,
      crewTimesheetStatusMap: state => state.crewTimesheetStatusMap,
    }),
    ...mapStateOfCrewAccount({
      crewAccount: state => state.crewAccount,
    }),
    timesheetHistoryList() {
      const workList = this.localData.timesheet_history_list || [];
      return workList;
    },
    dispUpdatedAt() {
      return this.localData.updated_at
        ? moment(this.localData.updated_at)
            .local()
            .format("YYYY/MM/DD HH:mm")
        : null;
    },
    validateForm() {
      return (
        !this.errors.has("daytimeInDate") &&
        !this.errors.has("daytimeInTime") &&
        !this.errors.has("daytimeOutDate") &&
        !this.errors.has("daytimeOutTime") &&
        !this.errors.has("daytime_range") &&
        !this.errors.has("daytimapproverAuthoritye_range") &&
        !this.errors.has("comment_memo") &&
        this.daytimeInDate &&
        this.daytimeInTime &&
        this.daytimeOutDate &&
        this.daytimeOutTime &&
        this.localData.crew_task &&
        this.commentMemo &&
        this.validateForDatetimeRange()
      );
    },

    dispCrewTasks() {
      const dispCrewTasks = this.crewTasks.map(task => {
        task.dispLabel = task.is_custom
          ? task.label
          : this.$t(`Views.Crew.LaborRecord.Tasks.${task.label}`);
        return task;
      });
      dispCrewTasks.sort((a, b) => {
        // sort_orderでソート
        let comparison = 0;
        if (a.sort_order > b.sort_order) {
          comparison = 1;
        } else if (a.sort_order < b.sort_order) {
          comparison = -1;
        }
        return comparison;
      });
      return dispCrewTasks;
    },
  },
  watch: {
    activeSidebarCrew(val) {
      if (val) {
        this.initLocalData();
        this.$validator.reset();
      }
    },
    daytimeInDate() {
      this.validateForDatetimeRange();
    },
    daytimeInTime() {
      this.validateForDatetimeRange();
    },
    daytimeOutDate() {
      this.validateForDatetimeRange();
    },
    daytimeOutTime() {
      this.validateForDatetimeRange();
    },
  },
  methods: {
    initLocalData() {
      if (this.inputParam.id) {
        console.debug("### this.inputParam", this.inputParam);

        this.localData = JSON.parse(JSON.stringify(this.inputParam));

        this.daytimeInDate = moment(this.localData.daytime_in)
          .local()
          .toDate();
        this.daytimeInTime = moment(this.localData.daytime_in)
          .local()
          .format("HH:mm");
        this.daytimeOutDate = moment(this.localData.daytime_out)
          .local()
          .toDate();
        this.daytimeOutTime = moment(this.localData.daytime_out)
          .local()
          .format("HH:mm");

        this.crewTask = this.dispCrewTasks.find(
          x => x.id === this.inputParam.crew_task.id
        );
      }
    },

    validateForDatetimeRange() {
      this.$validator.errors.remove("daytime_range");
      if (!this.daytimeInDate || !this.daytimeOutDate) {
        return true;
      }
      if (
        moment(this.daytimeInDate)
          .startOf("days")
          .valueOf() >
        moment(this.daytimeOutDate)
          .startOf("days")
          .valueOf()
      ) {
        this.$validator.errors.add({
          field: "daytime_range",
          msg: "終了日は開始日よりも未来に設定してください。",
        });
        return false;
      } else if (
        moment(this.daytimeInDate)
          .startOf("days")
          .valueOf() ==
          moment(this.daytimeOutDate)
            .startOf("days")
            .valueOf() &&
        this.daytimeInTime >= this.daytimeOutTime
      ) {
        this.$validator.errors.add({
          field: "daytime_range",
          msg: "終了日は開始日よりも未来に設定してください。",
        });
        return false;
      }
      return true;
    },

    onFormScroll() {
      if (this.$refs.daytimeInTimePicker) {
        this.$refs.daytimeInTimePicker.$vnode.elm._flatpickr.close();
      }
      if (this.$refs.daytimeOutTimePicker) {
        this.$refs.daytimeOutTimePicker.$vnode.elm._flatpickr.close();
      }
    },

    getCrewTaskLabel(crewTask) {
      if (crewTask && crewTask.localized_key) {
        return this.$t(
          "Views.Crew.LaborRecord.Tasks." + crewTask["localized_key"]
        );
      }
      return "-";
    },

    formatYmdhmJa(val) {
      return val
        ? moment(val)
            .local()
            .format("YYYY年MM月DD日 HH:mm")
        : null;
    },

    scrollEndAdjust() {
      setTimeout(() => {
        this.$refs.crewTimesheetEditForm.scrollTop = this.$refs.crewTimesheetEditForm.scrollHeight;
      }, 200);
    },
    onCancel() {
      this.localData = {};
      this.$nextTick(() => {
        this.$emit("close");
      });
    },
    async onSubmit() {
      this.$validator.errors.remove("daytimeInDateDuplication");
      this.$validator.errors.remove("daytimeOutDateDuplication");

      let checkValidate = await this.$validator.validateAll();
      let checkvalidateForDatetimeRange = this.validateForDatetimeRange();
      if (!checkValidate || !checkvalidateForDatetimeRange) {
        return false;
      }

      const dispId =
        moment(this.localData.daytime_in)
          .local()
          .format("YYYY/MM/DD") +
        "〜" +
        moment(this.localData.daytime_out)
          .local()
          .format("YYYY/MM/DD");

      const daytimeIn = moment(
        moment(this.daytimeInDate).format("YYYY-MM-DD") +
          `T${this.daytimeInTime}`
      ).toISOString();
      const daytimeOut = moment(
        moment(this.daytimeOutDate).format("YYYY-MM-DD") +
          `T${this.daytimeOutTime}`
      ).toISOString();

      let payload = {
        crew_task_id: this.crewTask.id,
        daytime_in: daytimeIn,
        daytime_out: daytimeOut,
        hash: this.localData.hash,
        version: this.localData.version,
      };

      if (this.inputParam.id) {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
        try {
          console.debug(
            "### 更新API",
            this.crewAccount.id,
            this.inputParam.id,
            payload
          );
          const res = await enterpriseCrewTimesheetApi.update(
            this.crewAccount.id,
            this.inputParam.id,
            payload
          );
          if (res.status) {
            // approval もコールして差し戻し
            const payaloadApproval = {
              memo: this.commentMemo,
              version: res.data.version,
            };

            const resApproval =
              this.inputParam.display_status !== 4
                ? await enterpriseCrewTimesheetApprovalApi.update(
                    this.crewAccount.id,
                    this.inputParam.id,
                    payaloadApproval
                  )
                : await enterpriseCrewTimesheetApprovalApi.delete(
                    this.crewAccount.id,
                    this.inputParam.id,
                    payaloadApproval
                  );
            if (resApproval.status) {
              this.$vs.notify({
                title: `打刻記録設定`,
                text: `${dispId}の打刻記録を差し戻しました`,
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
              });
              this.$emit("updatedId", this.inputParam.id);
            } else {
              Vue.$log.warn(
                "error at enterpriseCrewTimesheetApprovalApi.update() ",
                this.crewAccount.id,
                this.inputParam.id,
                payaloadApproval,
                resApproval
              );

              this.$vs.notify({
                title: `打刻記録設定`,
                text: `${dispId}の打刻記録を差し戻しできませんでした`,
                color: "warning",
                iconPack: "feather",
                icon: "icon-check",
              });
            }
          } else if (res.code == 422) {
            // 打刻重複エラー
            let daytimeInErrorString = "";
            let daytimeOutErrorString = "";
            res.data.validation_results.forEach((element, index) => {
              if (element.target == "daytimeIn") {
                daytimeInErrorString = daytimeInErrorString + element.message;
                if (index != res.data.validation_results.length)
                  daytimeInErrorString = daytimeInErrorString + "\n";
              } else if (element.target == "daytimeOut") {
                daytimeOutErrorString = daytimeOutErrorString + element.message;
                if (index != res.data.validation_results.length)
                  daytimeOutErrorString = daytimeOutErrorString + "\n";
              }
            });
            this.$validator.errors.add({
              field: "daytimeInDateDuplication",
              msg: daytimeInErrorString,
            });
            this.$validator.errors.add({
              field: "daytimeOutDateDuplication",
              msg: daytimeOutErrorString,
            });
            Vue.$log.warn(
              "error at enterpriseCrewTimesheetApi.update() ",
              this.crewAccount.id,
              this.inputParam.id,
              payload,
              res
            );
            this.$vs.notify({
              title: `打刻記録設定`,
              text: `${dispId}の打刻記録を差し戻しできませんでした`,
              color: "warning",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.$vs.loading.close();
            return;
          } else {
            Vue.$log.warn(
              "error at enterpriseCrewTimesheetApi.update() ",
              this.crewAccount.id,
              this.inputParam.id,
              payload,
              res
            );

            this.$vs.notify({
              title: `打刻記録設定`,
              text: `${dispId}の打刻記録を差し戻しできませんでした`,
              color: "warning",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.localData = {};
            this.$nextTick(() => {
              this.$emit("reloadList");
              this.$emit("close");
            });
          }
        } catch (e) {
          Vue.$log.warn(
            "error at enterpriseCrewTimesheetApi.update() ",
            this.crewAccount.id,
            this.inputParam.id,
            payload,
            e
          );
          this.$vs.notify({
            title: `打刻記録設定`,
            text: `${dispId}の打刻記録を差し戻しできませんでした`,
            color: "warning",
            iconPack: "feather",
            icon: "icon-check",
          });
        }
        this.$vs.loading.close();
        this.localData = {};
        this.$nextTick(() => {
          this.$emit("reloadList");
          this.$emit("close");
        });
      }
    },
  },
  created() {
    this.initLocalData();
  },
  mounted() {
    this.$nextTick(() => {
      document.querySelectorAll(".flatpickr-calendar").forEach(timeElement => {
        timeElement.style["max-width"] = "250px";
      });
    });
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.crew-timesheet-edit {
  label {
    font-family: $aisea-font-family;
    font-size: 14px;
    font-weight: 600;
  }

  .required label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger), 1);
    }
  }

  .text-danger {
    white-space: pre-line;
  }

  .v-select {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    input {
      height: 2rem;
    }
  }

  .vdp-datepicker__calendar {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    .selected {
      background: $aisea-blue !important;
    }
  }

  .crew-timesheet-edit-form-row {
    flex-direction: column;
    margin: 24px 0;
    padding-right: 8px;
  }

  .vs__search::placeholder {
    color: $aisea-light-gray;
  }

  .vdp-datepicker input {
    padding-left: 2.4rem;
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    &::placeholder {
      color: $aisea-light-gray;
      font-size: smaller;
    }
  }

  .flatpickr-input.active {
    border: 1px solid $aisea-blue;
  }

  .vs-collapse-item--header {
    padding: 0;
  }

  textarea {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    &::placeholder {
      color: $aisea-light-gray;
    }
  }
}
</style>
